export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6945.c0f1fc02.jpg";